<template>Categories</template>
<script src="./CategoriesView.js"></script>
